

















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class InputComponent extends Vue {
  @Prop({ default: "button" }) readonly text!: string;
  @Prop({ default: "" }) readonly icon!: string;
  @Prop({ default: "secondary", validator: (val) => ["secondary", "primary", "backStyle", "nonStyle"].includes(val) })
  readonly styleButton!: string;
  @Prop({ default: "purple", validator: (val) => ["purple", "mint", "blue", "white", "red"].includes(val) })
  readonly theme!: string;
  @Prop({ default: "black", validator: (val) => ["black", "purple", "blue"].includes(val) })
  readonly textColor!: string;
  @Prop({ default: "white" }) readonly color!: string;

  @Prop({ default: "16px" }) readonly textSize!: string;
  @Prop({ default: "lig" }) readonly textStyle!: string;
  @Prop({ default: "40px" }) readonly height!: string;
  @Prop({ default: "" }) readonly width!: string;
  @Prop({ default: "20px" }) readonly radius!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly lock!: boolean;
  @Prop({ default: false }) readonly canNotAccess!: boolean;

  created() {
    let widthStr = this.width;
    widthStr = widthStr.split("px")[0];
    const widthNumber = Number(widthStr);
    if (widthNumber < 160) {
      this.widthMin = "";
    }
  }

  private widthMin = "160px";
}
